<template lang="pug">
div
  .md-headline Ads
  // Dfp
  dfp(v-if='!isLive', :ads='ads', :platforms='platforms' @error='emitError', :formSubmitted='formSubmitted', :validations='validations')
  // Vast
  vast(v-if='!ads.dfpEnabled', :ads='ads', :platforms='platforms' @error='emitError', :formSubmitted='formSubmitted', :validations='validations')
  // ImageBanner
  image-banner(v-if='!ads.dfpEnabled', :ads='ads', :platforms='platforms' @error='emitError', :formSubmitted='formSubmitted', :validations='validations')
  // Ooyala
  ooyala(v-else, :ooyalaParams='ads.ooyala', :formSubmitted='formSubmitted', :validations='validations.ooyala')
</template>

<script>
  import Dfp from '../../../shared-components/Dfp';
  import Vast from '../../../shared-components/Vast';
  import ImageBanner from '../../../shared-components/ImageBanner';
  import Ooyala from '../../../shared-components/Ooyala';

  export default {
    components: {
      Dfp,
      Vast,
      ImageBanner,
      Ooyala
    },
    props: {
      ads: {
        type: Object,
        required: true,
        default: () => ({})
      },
      platforms: {
        type: Object,
        required: true,
        default: () => ({})
      },
      isLive: {
        type: Boolean,
        default: false
      },
      formSubmitted: {
        type: Boolean,
        default: false
      },
      validations: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },
    methods: {
      emitError(msg) {
        this.$emit('error', msg);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .form-wrapper-frame {
    width: 100%;
    padding: 25px;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/form-components/AdsForm.vue